import $ from 'jquery';

const instances = [];

function pad( num ) {
	num = parseInt( num, 10 );

	return ( num < 10 ) ? `0${num}` : String( num );
}

function experts( selector = '.experts .experts__wrap', settings = {} ) {
	const config = Object.assign( {
		adaptiveHeight: true,
		fade: true,
		draggable: false,
	}, settings );

	const $node = $( selector );
	const $experts = $node.find( '.experts__expert' );

	// preload thumbnails
	$experts.each( expert => {
		if ( $(expert).data('thumbnail') ) {
			new Image( $(expert).data('thumbnail' ) );
		}
	} );

	let $pager;
	let $total;
	let $current;
	let $slickPrev;
	let $slickNext;

	const $prevFigure = $( '<figure class="experts__thumb experts__thumb--prev"></figure>' );
	const $nextFigure = $( '<figure class="experts__thumb experts__thumb--next"></figure>' );

	const $prevThumb = $( '<img src="" alt="" />' ).appendTo( $prevFigure );
	const $nextThumb = $( '<img src="" alt="" />' ).appendTo( $nextFigure );

	$node.on( 'init', ( e, slick ) => {
		$pager = $( '<div class="pager"></div>' ).appendTo( $node );

		$slickPrev = $node.find( '.slick-prev' ).appendTo( $pager );
		$current   = $( `<div class="pager__current">${ pad( 1 ) }</div>` ).appendTo( $pager );
		$total     = $( `<div class="pager__total">${ pad( $experts.length ) }</div>` ).appendTo( $pager );
		$slickNext = $node.find( '.slick-next' ).appendTo( $pager );

		$prevFigure.prependTo( $pager ).on( 'click', () => slick.slickPrev() );
		$nextFigure.appendTo( $pager ).on( 'click', () => slick.slickNext() );
	} );

	$node.on( 'setPosition', ( e, slick ) => {
		const currentSlide = slick.slickCurrentSlide();

		const $prevExpert = $( $experts[ currentSlide === 0 ? $experts.length - 1 : currentSlide - 1 ] );
		const $nextExpert = $( $experts[ currentSlide === $experts.length - 1 ? 0 : currentSlide + 1 ] );

		$prevThumb.attr( 'src', $prevExpert.data( 'thumbnail' ) );
		$nextThumb.attr( 'src', $nextExpert.data( 'thumbnail' ) );

		console.log( 'setPosition', $prevExpert, $nextExpert );
	} );

	$node.slick( config );


	$node.on( 'afterChange', ( event, slick, currentSlide, nextSlide ) => $current.text( pad( currentSlide + 1 ) ) );

	instances.push( $node );

	return $node;
}

document.addEventListener( 'DOMContentLoaded', () => experts() );

export default {
	experts,
	instances,
}
